import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
    name: "ErrorGlobalModal",
    props: {
        titleLabel: {
            default: "Sorry, an error occured.",
            required: true
        },
        buttonLabel: {
            default: "Reload the page",
            required: true
        }
    },
    setup(props){

        const store = useStore()
        
        const modalVisibiltyState = computed(() => store.state.main.global_error_modal_visibility_state)

        const reloadPage = () => location.reload() 

        const closeModal = () => store.commit('main/set_global_error_modal_visibility_state', false)
        
        return {
            closeModal,
            reloadPage,
            modalVisibiltyState,
            title : props.titleLabel,
            buttonLabel : props.buttonLabel
        }
    }
}